import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from '../components/header';
import AiPortfolioSection from '../components/sections/aiPortfolioSection';
import Footer from '../components/sections/footer';
import MobileContactBar from '../components/mobileContactBar';

const AiPortfolioPage: React.FC = () => {
  return (
    <div className="mx-4 sm:mx-16 md:mx-24 lg:mx-32 xl:mx-64 2xl:mx-80">
      <Header />
      <div className="mt-8 md:mt-16">
        <Link
          to="/"
          className="flex gap-2 items-center w-fit text-sm font-medium text-blackSecondary hover:text-brand brand-transition"
        >
          <ArrowLeft className="h-4 w-4" />
          <p>Back to home</p>
        </Link>
      </div>
      <AiPortfolioSection />
      <div className="mt-16 border-b" />
      <Footer />
      <MobileContactBar />
    </div>
  );
};

export default AiPortfolioPage;
